import { useState, useEffect, Fragment } from 'react';
import defaultTheme from 'tailwindcss/defaultTheme';
import {
  fetchRunTotalsByRpmAcctId,
  getRunTotalsByRpmAcctLoadingSubject,
  getRunTotalsByRpmAcctSubject,
  RPMAcctRunTotal
} from '../../../store/RunTotal';
import { BasicDataGrid } from '../Table/BasicDataGrid';
import { ComponentSpinner } from '../Loading/ComponentSpinner';
import { RPMAcctRunTotalsColDefs } from './RPMAcctRunTotalsColDefs';

export const RunTotalTableStyles = {
  maxHeight: '32.5rem',
  fontFamily: ['"Helvetica Neue"', '"Segoe UI"', '"Ariel"', ...defaultTheme.fontFamily.sans].join(','),
  '.MuiDataGrid-columnHeader': {
    fontSize: '.75rem',
    fontWeight: 'bold'
  },
  '.MuiDataGrid-columnHeaders': {
    position: 'sticky',
    top: 0
  },
  '.MuiDataGrid-columnHeaders div[role="row"]': {
    backgroundColor: '#F7F7F7'
  },
  '.grey-background': {
    backgroundColor: '#F7F7F7',
    fontWeight: 'bold',
    fontSize: '.75rem'
  },
  borderWidth: '0',
  borderBottomLeftRadius: '.75rem',
  borderBottomRightRadius: '.75rem'
};

export interface RPMAcctRunTotalsProps {
  rpmAcctId: string;
}

export const RPMAcctRunTotals = ({ rpmAcctId }: RPMAcctRunTotalsProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [runTotals, setRunTotals] = useState<RPMAcctRunTotal[]>([]);

  useEffect(() => {
    const loadingSub = getRunTotalsByRpmAcctLoadingSubject().subscribe((l) => setLoading(l));
    const dataSub = getRunTotalsByRpmAcctSubject().subscribe((rt) =>
      setRunTotals(rt?.totals?.filter((item) => item.id !== 'TOTAL') || [])
    );
    return () => {
      if (loadingSub) loadingSub.unsubscribe();
      if (dataSub) dataSub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (rpmAcctId) fetchRunTotalsByRpmAcctId(rpmAcctId);
  }, [rpmAcctId]);

  return (
    <div className="w-full">
      <Fragment>
        {loading && (
          <div className="flex h-[45rem] m-auto">
            <ComponentSpinner label="Loading data..." />
          </div>
        )}
        {!loading && (
          <BasicDataGrid
            dataTestId="rmpAcct-run-totals"
            rows={runTotals}
            columns={RPMAcctRunTotalsColDefs}
            sxStyle={RunTotalTableStyles}
            className="flex"
          />
        )}
      </Fragment>
    </div>
  );
};
